import { useMutation } from 'react-query';

import { billingErrorToast } from '@components/BillingError/toast';
import { update_payment_path } from '@routes';
import { AddPaymentMethodParams, addPaymentMethod } from '@utils/backend-api/stripe';
import { BillingErrorPayload, normalizeBillingError } from '@utils/billingErrors';
import { ADD_PAYMENT_METHOD_FALLBACK_ERROR } from '@utils/stripePaymentError';

const useAddPaymentMethod = () => {
  const { mutate, isLoading, isError } = useMutation(
    (params: AddPaymentMethodParams = {}) => addPaymentMethod(params),
    {
      onSuccess: (data) => {
        window.location.href = data.redirect_to;
      },
      onError: (
        error: Partial<BillingErrorPayload> & { message?: string; redirect_to?: string }
      ) => {
        billingErrorToast(normalizeBillingError(error, ADD_PAYMENT_METHOD_FALLBACK_ERROR), {
          showCta: false,
        });
        window.location.href = error?.redirect_to || update_payment_path();
      },
    }
  );
  return { mutate, isLoading, isError };
};

export default useAddPaymentMethod;
